export default __webpack_public_path__ + "static/lte_3-4d3d4ad176cdd505c607e98e0bcaefab.png";